import { useQuery } from "react-query";
import { useContext } from "react";
import { FetchContext } from "../context/FetchContext";

export const usePermission = (projectId) => {
  const fetchContext = useContext(FetchContext);

  return useQuery(
    ["project", projectId.toString(), "permissions"],
    async () => {
      const { data } = await fetchContext.authAxios.get(
        `/projects/${projectId}/permissions`
      );
      return data;
    }
  );
};
